var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-container',{staticClass:"alarms"},[_c('el-aside',{staticClass:"alarms-aside"},[_c('bgi-aside')],1),_c('el-main',{staticClass:"alarms-main"},[_c('bgi-tiles')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }